/** Import react/libraries section **/
import React from 'react';
import { useSelector } from 'react-redux';

/** Import resources section **/

/** Import helpers section **/

/** Import component section **/

export const RouteAccess = (props) => {
  let permissions = useSelector((store) => store.permissions?.routes);
  return AccessControl({ ...props, permissions });
};

export const MenuAccess = (props) => {
  let permissions = useSelector((store) => store.permissions?.menus);
  return AccessControl({ ...props, permissions });
};

export const ActionAccess = (props) => {
  let permissions = useSelector((store) => store.permissions?.actions);
  return AccessControl({ ...props, permissions });
};

export const HasPermission = (permissionsRequest) => {
  let permissions = useSelector((store) => store.permissions?.actions);
  var result = false;
  if (permissionsRequest) {
    if (!Array.isArray(permissionsRequest))
      permissionsRequest = [permissionsRequest];
    result = permissionsRequest.every((item) => permissions.includes(item));
  }
  return result;
};

const AccessControl = ({
  permissionsRequest,
  permissions = [],
  children,
  renderNoAccess = () => {}
}) => {
  if (!Array.isArray(permissionsRequest))
    permissionsRequest = [permissionsRequest];
  const permitted = permissionsRequest.every((item) =>
    permissions.includes(item)
  );
  if (permitted && children) {
    return children;
  }
  renderNoAccess();
  return <></>;
};

export default AccessControl;
